import { z } from "zod";
import { MediaSchema } from "../Media";
export const PropertyValueSchema = z.object({
    id: z.string(),
    label: z.string(),
    icon: MediaSchema.optional(),
});
export const LabeledPropertyValueSchema = z.object({
    label: z.string(),
    value: PropertyValueSchema,
});
export const LabeledPropertyValueListSchema = z.object({
    label: z.string().optional(),
    values: z.array(PropertyValueSchema),
});
export const NumericalPropertyValueSchema = z.object({
    id: z.number().optional(),
    label: z.string(),
    icon: MediaSchema.optional(),
});
export const LabeledNumericalPropertyValueSchema = z.object({
    label: z.string().optional(),
    value: NumericalPropertyValueSchema,
});
//# sourceMappingURL=index.js.map